<template>
  <div class="app-surface flex min-h-screen flex-col">
    <NavBar />

    <main class="flex flex-1 items-center justify-center px-4 py-10">
      <div class="grid w-full max-w-5xl overflow-hidden rounded-2xl border border-jackfruit-100 bg-white shadow-soft md:grid-cols-[0.95fr_1.05fr]">
        <section class="hidden bg-gradient-to-br from-jackfruit-100 via-jackfruit-50 to-leaf-50 p-8 md:flex md:flex-col md:justify-between">
          <div>
            <div class="grid h-14 w-14 place-items-center rounded-2xl bg-jackfruit-pop text-3xl shadow-fruit">🍍</div>
            <h1 class="mt-8 text-4xl font-black leading-tight text-ink-900">你的下一章，马上开始。</h1>
            <p class="mt-4 text-sm leading-7 text-ink-600">
              登录菠萝蜜，继续追读收藏书籍，保存阅读进度，也可以在章末让 AI 写出新的剧情分支。
            </p>
          </div>
          <div class="rounded-xl bg-white/75 p-4">
            <p class="text-xs font-black text-pulp-600">今日推荐</p>
            <p class="mt-2 text-sm font-bold leading-6 text-ink-700">男频爽文、女频甜宠、悬疑烧脑都在书库等你。</p>
          </div>
        </section>

        <section class="p-6 sm:p-8">
          <div class="mb-8 text-center md:text-left">
            <div class="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-xl bg-jackfruit-100 text-2xl md:mx-0">🍍</div>
            <h2 class="text-3xl font-black text-ink-900">欢迎回来</h2>
            <p class="mt-2 text-sm text-ink-500">
              还没有账号？
              <router-link to="/register" class="font-black text-pulp-600 hover:text-pulp-700">立即注册</router-link>
            </p>
          </div>

          <form class="space-y-5" @submit.prevent="handleLogin">
            <div>
              <label for="phone" class="label">手机号</label>
              <div class="relative">
                <span class="absolute inset-y-0 left-0 flex items-center pl-3 text-sm font-bold text-ink-500">+86</span>
                <input
                  id="phone"
                  v-model="form.phone"
                  type="tel"
                  required
                  class="input pl-12"
                  placeholder="请输入手机号"
                  :class="{ 'border-red-300': errors.phone }"
                />
              </div>
              <p v-if="errors.phone" class="mt-1 text-sm text-red-600">{{ errors.phone }}</p>
            </div>

            <div>
              <div class="mb-1 flex items-center justify-between">
                <label for="password" class="label mb-0">密码</label>
                <a href="#" class="text-sm font-bold text-pulp-600 hover:text-pulp-700">忘记密码？</a>
              </div>
              <input
                id="password"
                v-model="form.password"
                type="password"
                required
                class="input"
                placeholder="请输入密码"
                :class="{ 'border-red-300': errors.password }"
              />
              <p v-if="errors.password" class="mt-1 text-sm text-red-600">{{ errors.password }}</p>
            </div>

            <label class="flex items-center gap-2 text-sm text-ink-600">
              <input v-model="form.rememberMe" type="checkbox" class="h-4 w-4 rounded border-ink-100 text-jackfruit-500 focus:ring-jackfruit-400" />
              记住我
            </label>

            <button
              type="submit"
              :disabled="loading"
              class="w-full rounded-xl bg-jackfruit-500 px-4 py-3 text-sm font-black text-ink-900 shadow-fruit transition hover:bg-jackfruit-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {{ loading ? '登录中...' : '开始阅读' }}
            </button>

            <div v-if="error" class="rounded-xl border border-red-100 bg-red-50 p-4 text-sm text-red-700">
              {{ error }}
            </div>
          </form>
        </section>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import NavBar from '@/components/NavBar.vue'

const router = useRouter()
const authStore = useAuthStore()

const form = reactive({
  phone: '',
  password: '',
  rememberMe: false
})

const errors = reactive({
  phone: '',
  password: ''
})

const loading = ref(false)
const error = ref('')

const validateForm = () => {
  let isValid = true
  errors.phone = ''
  errors.password = ''

  if (!form.phone) {
    errors.phone = '请输入手机号'
    isValid = false
  } else if (!/^1[3-9]\d{9}$/.test(form.phone)) {
    errors.phone = '请输入有效的手机号'
    isValid = false
  }

  if (!form.password) {
    errors.password = '请输入密码'
    isValid = false
  } else if (form.password.length < 6) {
    errors.password = '密码至少6位'
    isValid = false
  }

  return isValid
}

const handleLogin = async () => {
  if (!validateForm()) return

  loading.value = true
  error.value = ''

  try {
    const result = await authStore.login(form.phone, form.password)
    if (result.success) {
      router.push('/')
    } else {
      error.value = result.error || '登录失败'
    }
  } catch (err) {
    error.value = '登录过程中出现错误，请稍后重试'
    console.error('Login error:', err)
  } finally {
    loading.value = false
  }
}

if (import.meta.env.DEV) {
  form.phone = '13800138000'
  form.password = '123456'
}
</script>
